import {HttpEvent, HttpResponse} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import config_file from "../../../assets/server/roles_config.json";
import { LoggingService } from "./log.service";
import { RestfulService } from "./restful.service";
import * as ENDPOINT from "../../shared/constant/endPoint.js";
import { UtilsService } from "./utils.service";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  configurationFile: any = config_file;

  configFileIsLoaded = false;

  privileges: any;
  roles: any;

  constructor(
    private logger: LoggingService,
    private restful: RestfulService,
    private utils: UtilsService
  ) {
    this.setConfigurationFile(this.configurationFile || null);
  }

  /**
   * Caricamento del file di configurazione da backend
   */
  loadConfigurationFile(): Observable<any> {
    this.configFileIsLoaded = false;
    const endPoint = ENDPOINT.app_configuration;
    return this.get(endPoint);
  }

  /**
   * Questo metodo setta il file di configurazione in locale
   */
  setConfigurationFile(configurationFile: any = null): void {
    this.configurationFile = JSON.parse(JSON.stringify(configurationFile));
    this.configurationFile = JSON.parse(JSON.stringify(this.configurationFile));
    this.configFileIsLoaded = true;
    const { privileges, roles } = this.configurationFile;
    this.privileges = privileges;
    this.roles = roles;
  }

  /**
   * Stato del caricamento del file di configurazione
   */
  getLoadingConfigFileStatus(): boolean {
    return this.configFileIsLoaded;
  }

  /**
   * Ritorna `true` nel caso in cui il privilegio `privilege` esista all'interno della sezione
   * `sectionName`, `false` altrimenti
   */
  privilegeExistInSection(sectionName: string, privilege: string): boolean {
    if (this.configFileIsLoaded) {
      if (this.privileges[sectionName][privilege]) {
        return true;
      }
      return false;
    }
    return false;
  }

  /**
   * Ritorna `true` nel caso in cui l'utente con ruolo `role` abbia il privilegio `privilege`
   * per visualizzare la sezione `sectionName`, `false` altrimenti
   */
  userHasPrivilege(role: string, sectionName: string, privilege: string): boolean {
    if (this.configFileIsLoaded) {
      if (this.privilegeExistInSection(sectionName, privilege)) {
        if (this.roles[role][sectionName].includes(privilege)) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  }

  /* RESTFUL METHOD */

  post(endPoint: string, reqBody: any, localhost: boolean = false): Observable<any> {
    return Observable.create((observer) => {
      this.restful.post(endPoint, reqBody).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  put(endPoint: string, reqBody: any): Observable<any> {
    return Observable.create((observer) => {
      this.restful.put(endPoint, reqBody).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  delete(endPoint: string): Observable<any> {
    return Observable.create((observer) => {
      this.restful.delete(endPoint).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  get(endPoint: string): Observable<any> {
    return Observable.create((observer) => {
      this.restful.get(endPoint).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  responseHandler(response: HttpEvent<any>, observer: any): void {
    const outcome = response["outcome"];
    if (outcome.success === true) {
      this.logger.log("Service:", "SUCCESS", 200);
      observer.next(response);
    } else {
      this.logger.log("Service:", "FAILURE", 200);
      outcome.message = this.utils.manageErrorMsg(outcome);
      observer.error(outcome);
    }
  }
}
